import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Flex,
  Text,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { useParams } from "react-router-dom";
import usePersistedState from "utilities/usePersistedState";

export default function Configurator({ isOpen, onClose }) {
  const { projectId } = useParams();
  const [_, setSelectedSegments] = usePersistedState(
    `selectedSegments-${projectId}`,
    []
  );

  const { colorMode, toggleColorMode } = useColorMode();

  const handleClearSelectedSegments = () => {
    setSelectedSegments([]);
    window.location.reload();
  };

  const bgDrawer = useColorModeValue("white", "navy.800");
  const settingsRef = React.useRef();
  return (
    <>
      <Drawer
        blockScrollOnMount={false}
        finalFocusRef={settingsRef}
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === "rtl" ? "left" : "right"}
      >
        <DrawerContent bg={bgDrawer}>
          <DrawerHeader pt="24px" px="24px">
            <DrawerCloseButton />
            <Text fontSize="xl" fontWeight="bold" mt="16px">
              Settings
            </Text>
          </DrawerHeader>
          <DrawerBody pe="40px" ps="24px" w="340px">
            <Flex flexDirection="column">
              <Flex
                alignItems="center"
                justifyContent="space-between"
                mb="24px"
              >
                <Text fontSize="md" fontWeight="600" mb="4px">
                  Dark/Light
                </Text>
                <Button
                  color={colorMode === "light" ? "Dark" : "Light"}
                  onClick={toggleColorMode}
                >
                  Toggle {colorMode === "light" ? "Dark" : "Light"}
                </Button>
              </Flex>
              <Flex
                alignItems="center"
                justifyContent="space-between"
                mb="24px"
              >
                <Text fontSize="md" fontWeight="600" mb="4px">
                  Clear Selected Segments
                </Text>
                <Button
                  colorScheme="red"
                  onClick={handleClearSelectedSegments}
                  size="sm"
                >
                  Clear
                </Button>
              </Flex>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
